"use client";

import { ArrowDown, CalendarDays } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ScheduleYourConsultation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="8" id="schedule-your-consultation" className="bg-slate-50 text-foreground relative overflow-hidden border-y border-border">
      {}
      <span className="hidden lg:block absolute left-6 xl:left-12 top-1/2 -translate-y-1/2 font-serif italic text-primary/10 text-2xl xl:text-3xl rotate-[-8deg] select-none" aria-hidden="true">
        breathe easier
      </span>
      <span className="hidden lg:block absolute right-6 xl:right-12 top-1/2 -translate-y-1/2 font-serif italic text-primary/10 text-2xl xl:text-3xl rotate-[8deg] select-none" aria-hidden="true">
        sleep better
      </span>

      {}
      <div ref={ref} className={`relative z-10 min-h-[480px] flex flex-col items-center justify-center px-6 py-20 md:py-24 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="max-w-[800px] mx-auto text-center flex flex-col items-center gap-6 md:gap-8">
          <Badge variant="secondary" className="bg-chart-3 text-primary border-transparent rounded-md px-4 py-1.5 text-xs tracking-[0.15em] uppercase font-mono font-bold">
            New Patients Welcome
          </Badge>

          <h2 className="font-serif font-default text-foreground leading-[1.1] tracking-tight" style={{
          fontSize: "clamp(2.75rem, 6vw, 4.5rem)"
        }}>
            Expert Pulmonary &
            <br />
            <br />
            <em className="italic font-light">Sleep Medicine Care</em>
          </h2>

          <p className="text-foreground/90 text-base md:text-lg max-w-xl leading-relaxed font-default">Call to schedule an adult pulmonary or sleep medicine evaluation with Dr. Azmat Qayyum and Chaudhry Pulmonary Associates.</p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 items-center justify-center w-full sm:w-auto pt-2">
            <Button size="lg" className="bg-chart-3 text-primary hover:bg-chart-3/90 rounded-md px-7 py-6 h-auto text-sm font-bold tracking-wide w-full sm:w-auto shadow-md" asChild>
              <Link to="tel:+14126729240">
                <CalendarDays className="size-4" />
                Call (412) 672-9240
              </Link>
            </Button>
            <Button size="lg" variant="outline" className="bg-transparent border-foreground/40 text-foreground hover:bg-foreground/10 hover:text-foreground rounded-md px-7 py-6 h-auto text-sm font-medium tracking-wide w-full sm:w-auto" asChild>
              <Link to="/PulmonaryCarePage">
                Explore Services
                <ArrowDown className="size-4" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="relative w-full max-w-4xl mx-auto mt-14 md:mt-20 pt-8 border-t border-foreground/20">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-foreground/80 text-[10px] sm:text-xs tracking-[0.18em] uppercase font-mono text-center">
            <span>SERVING GREATER PITTSBURGH</span>
            <span className="hidden sm:inline text-chart-3">·</span>
            <span>Adult Pulmonary & Sleep Medicine</span>
            <span className="hidden sm:inline text-chart-3">·</span>
            <span>Mon–Fri Clinical Hours</span>
          </div>
        </div>
      </div>
    </section>;
}